module.exports = __webpack_public_path__ + "img/as.95a96e20.svg";